// extracted by mini-css-extract-plugin
export default {"standardFilterContainer":"StandardTable__standardFilterContainer___qPYMI","dataGridWapper":"StandardTable__dataGridWapper___OPSct"};